/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FolderWrapper_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FolderWrapperWrapper_viewer$ref: FragmentReference;
export type FolderWrapperWrapper_viewer = {|
  +id: string,
  +$fragmentRefs: FolderWrapper_viewer$ref,
  +$refType: FolderWrapperWrapper_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FolderWrapperWrapper_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "selectedItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "shouldFillInFolder",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]",
      "defaultValue": []
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FolderWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "selectedItemIds",
          "variableName": "selectedItemIds",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "shouldFillInFolder",
          "variableName": "shouldFillInFolder",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '366f7e74d597f4569f6a44f1637f2ecd';
module.exports = node;
